import { useEffect, useState } from "react";
import { ISelectOptions } from "../../../types/inputs";
import { Itinerante } from "../../../services/Itinerante";
import { useForm, Controller } from "react-hook-form";
import { IItineranteListProps } from "../../../types/itinerante";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";

const schema = z.object({
  cidade: z.string().optional(),
  dataRealizacao: z.string().optional(),
});

export const useFormScheduleFilterItinerant = () => {
  const [cidades, setCidades] = useState<ISelectOptions[]>(
    [] as ISelectOptions[]
  );

  const { control, handleSubmit, reset } = useForm<IItineranteListProps>({
    defaultValues: {
      cidade: "",
      dataRealizacao: "",
    },
    resolver: zodResolver(schema),
    mode: "all",
  });

  const getCities = (nome?: string) => {
    Itinerante.listar_cidades(nome).then(({ data }) => {
      const cidadesOptionsUnicas = data.map((i) => ({ label: i, value: i }));
      setCidades(cidadesOptionsUnicas);
    });
  };

  useEffect(() => {
    getCities();
  }, []);

  return {
    Controller,
    control,
    handleSubmit,
    reset,
    cidades,
    getCities,
  };
};
